"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyReturnTransfer = void 0;
const verifyTransferLeg_1 = require("./verifyTransferLeg");
const verifyReturnTransfer = (legs) => {
    return (0, verifyTransferLeg_1.verifyTransferLeg)(legs.outbound) || false;
};
exports.verifyReturnTransfer = verifyReturnTransfer;
